/**
 * Playlist service – kebutuhan playlist remote dipetakan ke repository.
 */

import * as repo from '../repository.js';
import { ENDPOINTS } from '../repository.js';

/**
 * URL default playlist remote.
 */
export const DEFAULT_PLAYLIST_URL = ENDPOINTS.PLAYLIST;

/**
 * Ambil playlist JSON dari server (GET).
 * @param {string} [url] – default ENDPOINTS.PLAYLIST
 * @param {{ timeout?: number }} [options]
 * @returns {Promise<object>} Raw response (biasanya { items } atau array)
 */
export async function fetchPlaylist(url, options = {}) {
  return repo.fetchPlaylistRaw(url || ENDPOINTS.PLAYLIST, options);
}

/**
 * Ambil playlist dari API 001 (GET /webos/playlist) dengan Bearer token.
 * @param {string} token
 * @param {{ timeout?: number }} [options]
 * @returns {Promise<{ ok: boolean, status: number, json: any }>}
 */
export async function fetchWebosPlaylist(token, options = {}) {
  return repo.getWebosPlaylist(token, options);
}
